
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../Assets/logo.jpg';

const Accueil = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans">

      <header className="flex justify-between items-center px-8 py-6 shadow-md sticky top-0 z-50 bg-white">
        <div className="flex items-center space-x-2">
          <img src={logo} alt="GenIaC Logo" className="h-20 w-auto object-contain" />
        </div>

        <nav className="flex items-center space-x-6 text-gray-700 font-medium">
          <Link to="/">Accueil</Link>
         <Link to="/solutions">Solutions</Link>
          <a href="#tarifs">Tarifs</a>
          <Link to="/home">Demo</Link>
          <Link to="/blog">Blog</Link>

          <Link to="/login">CONNEXION</Link>
          <Link to="/register">
            <button className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition">
              INSCRIPTION
            </button>
          </Link>
        </nav>
      </header>

      <section className="text-center py-24 bg-gradient-to-b from-blue-50 to-white px-6">
        <h1 className="text-4xl md:text-5xl font-bold mb-6 text-gray-800">
          Concevez, optimisez et déployez vos infrastructures cloud <br /> en toute simplicité.
        </h1>
        <div className="mt-8 space-x-4">
          <button className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition">
            DÉCOUVRIR GENIAC
          </button>
         <Link to="/demande-demo">
  <button className="border border-blue-600 text-blue-600 px-6 py-3 rounded-lg hover:bg-blue-50 transition">
    RECLAMER UNE DEMO
  </button>
</Link>


        </div>
      </section>
    </div>
  );
};

export default Accueil;
